






import { computed, defineComponent } from '@vue/composition-api';
import { FieldRow } from '@/store/types';
import { downloadFieldsCSV } from './helpers';

export default defineComponent({
	emits: ['ok'],
	setup(_, { root }) {
		const fieldRows = computed<FieldRow[]>(() => root.$store.getters['fieldsView/getFieldRows']);

		const onExport = () => {
			downloadFieldsCSV(fieldRows.value);
			root.$emit('ok');
		};

		return {
			onExport,
		};
	},
});
